if (!customElements.get('comenii-trending')) {
  customElements.define('comenii-trending', class extends HTMLElement {
    connectedCallback() {
      if (this.handleSwatch) return;
      this.cache = new Map();
      this.requests = new WeakMap();
      this.handleSwatch = this.onSwatch.bind(this);
      this.addEventListener('click', this.handleSwatch, true);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleSwatch, true);
      this.handleSwatch = null;
    }

    async onSwatch(event) {
      const link = event.target.closest('.pl-swatches-collection__link');
      if (!link || link.classList.contains('pl-swatches-collection__link--more')) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const card = link.closest('[data-trending-card]');
      if (!card || !this.contains(card)) return;
      const target = new URL(link.href, window.location.href);
      if (target.origin !== window.location.origin || !target.pathname.includes('/products/')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const requestId = Symbol();
      this.requests.set(card, requestId);
      if (link.getAttribute('aria-current') === 'page') {
        card.removeAttribute('aria-busy');
        return;
      }
      card.setAttribute('aria-busy', 'true');
      const requestUrl = new URL(target);
      requestUrl.searchParams.set('view', 'comenii-trending-card');
      requestUrl.searchParams.set('preview_theme_id', this.dataset.themeId);
      const key = requestUrl.href;
      try {
        if (!this.cache.has(key)) {
          this.cache.set(key, fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) }).then(response => {
            if (!response.ok) throw new Error('Card unavailable');
            return response.text();
          }).catch(error => {
            this.cache.delete(key);
            throw error;
          }));
        }
        const html = await this.cache.get(key);
        if (!this.isConnected || this.requests.get(card) !== requestId) return;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const incoming = documentFragment.querySelector('[data-trending-response]');
        const selectors = ['[data-trending-media]', '[data-trending-title]', '[data-trending-rating]', '[data-trending-prices]'];
        if (!incoming || !incoming.dataset.productId || !selectors.every(selector => incoming.querySelector(selector) && card.querySelector(selector))) {
          throw new Error('Invalid card response');
        }
        selectors.forEach(selector => {
          card.querySelector(selector).replaceWith(incoming.querySelector(selector));
        });
        card.querySelectorAll('.pl-swatches-collection__link:not(.pl-swatches-collection__link--more)').forEach(swatch => {
          const active = swatch === link;
          if (active) swatch.setAttribute('aria-current', 'page');
          else swatch.removeAttribute('aria-current');
          swatch.querySelector('.pl-swatches-collection__swatch-wrapper')?.classList.toggle('pl-swatches-collection__swatch-wrapper--active', active);
        });
        card.dataset.currentProductId = incoming.dataset.productId;
        const rating = card.querySelector('[data-oke-star-rating]');
        if (rating && window.okeWidgetApi?.initWidget) window.okeWidgetApi.initWidget(rating);
      } catch {
        if (this.isConnected && this.requests.get(card) === requestId) window.location.assign(target.href);
      } finally {
        if (this.requests.get(card) === requestId) card.removeAttribute('aria-busy');
      }
    }
  });
}
